import { hasPermission } from './Permissions'

export const canViewAnnouncements = () => hasPermission('announcements.view')
export const canManageAnnouncements = () => hasPermission('announcements.manage')
export const canManageAnnouncementSections = () => hasPermission('announcements.sections.manage')

export function hasAnyAnnouncementsMenuAccess() {
    return canViewAnnouncements() || canManageAnnouncements() || canManageAnnouncementSections()
}

/** Texto blanco u oscuro según la luminancia del color de fondo (hex #rrggbb). */
export function contrastTextColor(hex) {
    const match = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '')
    if (!match) return '#ffffff'
    const [r, g, b] = match.slice(1).map((h) => parseInt(h, 16) / 255)
    const lin = (c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4)
    const luminance = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b)
    return luminance > 0.45 ? '#1e2a4a' : '#ffffff'
}

const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']

/** 'YYYY-MM-DD' → '28 sep 2026' */
export function formatAnnouncementDate(ymd) {
    if (!ymd) return ''
    const [y, m, d] = ymd.slice(0, 10).split('-').map(Number)
    if (!y || !m || !d) return ymd
    return `${d} ${MONTHS[m - 1]} ${y}`
}

/** 'YYYY-MM-DD HH:mm' → '28 sep 2026, 14:05' */
export function formatAnnouncementDateTime(value) {
    if (!value) return ''
    const [date, time] = value.split(' ')
    return time ? `${formatAnnouncementDate(date)}, ${time}` : formatAnnouncementDate(date)
}

/** Date local → 'YYYY-MM-DD' (sin desfase de zona horaria). */
export function toYmd(date) {
    if (!date) return ''
    const pad = (n) => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/** 'YYYY-MM-DD' → Date local a medianoche. */
export function fromYmd(ymd) {
    if (!ymd) return null
    const [y, m, d] = ymd.split('-').map(Number)
    return y && m && d ? new Date(y, m - 1, d) : null
}
